<template>
  <div :class="'repeater-row-'+workflowIndex" class="row repeater-row-lg">
    <div class="form-group col-lg">
      <label class="m-show-lg">{{ $t('products.workflows.assignToWorkflow') }}</label>
      <v-select :clearable="false"
                :options="usedWorkflows"
                :reduce="usedWorkflows => usedWorkflows.id"
                :selectOnTab="true"
                @input="sentInput"
                label="name"
                v-model="workflowName"
      >
        <div slot="no-options">{{ $t('products.workflows.none') }}</div>
      </v-select>
    </div>
    <div class="col repeater-actions-lg repeater-last-lg">
      <add-remove-row
              @click.native="$emit('addWorkflowRow')"
              v-if="workflowIndex === (workflows.length-1)"
      />
      <add-remove-row
              @click.native="$emit('workflowRemoved', workflowIndex)"
              v-else
              :iconClass="'minus'"
      />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import addRemoveRow from '../general/addRemoveRow'

  //@vuese
  // @group Products
  export default {
    name: 'WorkflowRow',
    components: {
      addRemoveRow
    },
    inject: ['$validator'],
    props: {
      usedWorkflows: Array,
      workflows: Array,
      workflow: String,
      workflowIndex: Number
    },
    data() {
      return {
        workflowName: null
      }
    },
    computed: {
      ...mapGetters('workflows', [
        'getWorkflows',
        'getWorkflowName'
      ])
    },
    methods: {
      //@vueuse
      sentInput(event) {
        this.$emit('input', event)
      }
    },
    created() {
      if(this.workflow) {
        this.workflowName = this.getWorkflowName(this.workflow)
      }
    }
  }
</script>